/** SankeyChart — tier-2 adapter. */
import { useMemo } from 'react';
import { Chart, type ChartBaseProps } from './Chart';
import type { ChartConfig } from './types';

export interface SankeyChartProps extends ChartBaseProps {
  /** Field name holding the link's source node. */
  sourceKey: string;
  /** Field name holding the link's target node. */
  targetKey: string;
  /** Field name holding the link weight. */
  valueKey: string;
  title?: string;
}

export function SankeyChart({
  sourceKey,
  targetKey,
  valueKey,
  title,
  ...rest
}: SankeyChartProps) {
  const config: ChartConfig = useMemo(
    () => ({
      title,
      chartType: 'sankey',
      series: [
        {
          id: valueKey,
          name: title ?? valueKey,
          fields: { x: sourceKey, target: targetKey, value: valueKey },
        },
      ],
    }),
    [sourceKey, targetKey, valueKey, title],
  );
  return <Chart config={config} {...rest} />;
}
